import { z } from 'zod/v4';

import type { ActionDefinition } from '../types';

export const AUTOMATION_RULES_CREATE_ACTION_ID = 'automation-rules-creator-v2';

export const automationRulesCreateDefinition: ActionDefinition = {
  name: 'Create Automation Rule',
  description: 'Opens the automation rules editor and prefills a rule based on LLM-generated configuration',
  parameters: z.object({
    name: z.string(),
    active: z.boolean().optional(),
    ruleType: z.enum(['everyOrder', 'specificCriteria']).optional(),
    filterCriteria: z
      .object({
        conditions: z.array(
          z.object({
            fieldType: z.string(),
            operator: z.string(),
            // Optional: some operators carry no value (e.g. valueEqualsTrue/False, isBlank, valueAreEmpty).
            // Accepts number because numeric/currency/weight comparisons often arrive unquoted; downstream coerces via String().
            value: z.union([z.string(), z.number()]).optional(),
            logicalOperator: z.string().optional(),
          }),
        ),
      })
      .optional(),
    orderRuleActions: z.array(
      z.object({
        actionTypeId: z.number(),
        parameter: z.union([z.string(), z.null()]).optional(),
        intParameter: z.union([z.number(), z.null()]).optional(),
      }),
    ),
    reasoning: z.string().optional(),
  }),
  category: 'Automation',
};
